import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=46d9e196&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9e196",
  null
  
)

export default component.exports